import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { AndExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/AndExpression";
import { ComparisonExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/ComparisonExpression";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { IParameterDialog, ParameterDialog, ParameterDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ParameterDialog";
import { PropertyEditorComboBoxApplicationEntity } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxApplicationEntity";
import { PropertyEditorComboBoxLookupItem } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxLookupItem";
import { NAMESPACE } from "./_Namespace";

export type ProcessInstanceFilterParameterDialogPropertyValues =
    ParameterDialogPropertyValues
    & {
    };

export type ProcessInstanceFilterParameterDialogProperties = {
    [name in keyof ProcessInstanceFilterParameterDialogPropertyValues]: Property<ProcessInstanceFilterParameterDialogPropertyValues[name]>
};

export interface IProcessInstanceFilterParameterDialog extends IParameterDialog, ProcessInstanceFilterParameterDialogProperties
{
}

export class ProcessInstanceFilterParameterDialog extends ParameterDialog implements IProcessInstanceFilterParameterDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ProcessInstanceFilterParameterDialog";
    public static override className = "ProcessInstanceFilterParameterDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ProcessInstanceFilterParameterDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected propertyEditorProcess?: PropertyEditorComboBoxApplicationEntity;
    protected propertyEditorStatusLookupItem?: PropertyEditorComboBoxLookupItem;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ProcessInstanceFilterParameterDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.propertyEditorProcess =
            new PropertyEditorComboBoxApplicationEntity({
                editMode: true,
                primaryEntity: "Processes",
                primaryEntityDescriptionProperty: "name",
                propertyDisplayName: "Process"
            })
                .appendTo(this);

        this.propertyEditorStatusLookupItem =
            new PropertyEditorComboBoxLookupItem({
                editMode: true,
                lookupType: "Process Instance Statuses",
                propertyDisplayName: "Status"
            })
                .appendTo(this);

        return $$element;
    }
    public override createExpression()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");
        Assert.isNotNullOrUndefined(this.propertyEditorStatusLookupItem, "this.propertyEditorStatusLookupItem");

        const
            expression = new AndExpression(),
            processId = this.propertyEditorProcess.value.get(),
            statusLookupItemId = this.propertyEditorStatusLookupItem.value.get();

        if (processId)
            expression.add(new ComparisonExpression({ path: "processVersion.processId", value: processId }));

        if (statusLookupItemId)
            expression.add(new ComparisonExpression({ path: "statusLookupItemId", value: statusLookupItemId }));

        return expression.count() > 0 ? expression : null;
    }
    public override openAsync()
    {
        const
            dataSource = {};

        Assert.isNotNullOrUndefined(this.propertyEditorProcess, "this.propertyEditorProcess");
        Assert.isNotNullOrUndefined(this.propertyEditorStatusLookupItem, "this.propertyEditorStatusLookupItem");

        this.propertyEditorProcess.dataSource.set(new DataSource({ data: dataSource }));
        this.propertyEditorStatusLookupItem.dataSource.set(new DataSource({ data: dataSource }));

        return super.openAsync();
    }

    // #endregion

    // #endregion
}

